export const media = {
  desktop: '(min-width: 1001px)',
  mobile: '(max-width: 1000px)',
  tablesktop: '(min-width: 768px)',
  tablet: '(min-width: 768px) and (max-width: 1000px)',
  phonablet: '(max-width: 767px)',
  phablet: '(min-width: 480px) and (max-width: 767px)',
  phone: '(max-width: 479px)'
};
